import { Injectable, signal } from '@angular/core';

export type CookieConsentStatus = 'allow' | 'dismiss' | 'deny';

const CONSENT_STORAGE_KEY = 'gabali_cookie_consent';
const CONSENT_STATUSES = new Set<CookieConsentStatus>(['allow', 'dismiss', 'deny']);

@Injectable({ providedIn: 'root' })
export class CookieConsentService {
  readonly visible = signal(false);

  private initialised = false;

  init(): void {
    if (this.initialised || typeof window === 'undefined') {
      return;
    }

    this.initialised = true;
    this.visible.set(!this.hasStoredConsent());
  }

  dismiss(): void {
    this.setConsent('dismiss');
  }

  deny(): void {
    this.setConsent('deny');
  }

  allow(): void {
    this.setConsent('allow');
  }

  private setConsent(status: CookieConsentStatus): void {
    this.persistConsent(status);
    this.visible.set(false);
  }

  private hasStoredConsent(): boolean {
    return this.readStoredConsent() !== undefined;
  }

  private readStoredConsent(): CookieConsentStatus | undefined {
    try {
      const value = localStorage.getItem(CONSENT_STORAGE_KEY);
      return value && CONSENT_STATUSES.has(value as CookieConsentStatus)
        ? (value as CookieConsentStatus)
        : undefined;
    } catch {
      return undefined;
    }
  }

  private persistConsent(status: CookieConsentStatus): void {
    if (!CONSENT_STATUSES.has(status)) {
      return;
    }

    try {
      localStorage.setItem(CONSENT_STORAGE_KEY, status);
    } catch {
      // localStorage may be unavailable in private browsing.
    }
  }
}
